import axios, { AxiosRequestConfig } from 'axios';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';

const BASE_API_URL = process.env.REACT_APP_API_URL;
const BASE_API_KEY = process.env.REACT_APP_API_KEY;

interface ApiServiceOptions extends AxiosRequestConfig {
  useToken?: boolean;
  isInternal?: boolean;
}

const makeRequest = <T>(urlPath: string, options: ApiServiceOptions) => {
  const { useToken = true, isInternal, baseURL = BASE_API_URL, ...otherOptions } = options;

  const headers = options?.headers ?? {};
  if (isInternal) headers['x-api-key'] = BASE_API_KEY;
  if (useToken) headers['Authorization'] = 'Bearer ' + getToken();

  return axios.request<T>({ ...otherOptions, url: urlPath, baseURL, headers });
};

const getToken = () => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  return token;
};
const redirectToLogin = () => {
  if (window.location)
    window.location.replace(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}?expired=true`);
};
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.data.message === 'token has expired') {
      localStorage.clear();
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export const apiService = {
  get: <T = any>(urlPath: string, options: ApiServiceOptions = {}) =>
    makeRequest<T>(urlPath, { method: 'get', ...options }),
  patch: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'patch', ...options }),
  post: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'post', ...options }),
  put: <T = any>(urlPath: string, options: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'put', ...options }),
  delete: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'delete', ...options })
};
